module.exports = __webpack_public_path__ + "img/friction-icon-min.a002001a.png";